import { openPageEntry } from "./openPage";

export const adCenterEntries = [
  openPageEntry("adCenter", "It's where you view and manage all advertisements for your Organization.", [
    "Where do I manage our ads?",
    "Where are our advertisements?",
  ]),
];
